import React from "react";
import ReactDOM from "react-dom";
import { setRuntimeConfig } from "nr1";
import { resolveConfig } from "./runtime-config";
import { configureCognito } from "./auth/cognito";
import { HEALTH_API_BASE_GLOBAL } from "./nerdlets/home/constants/healthApi";
import { STANDALONE_GLOBAL } from "./nerdlets/home/constants/healthEndpoints";
import StandaloneShell from "./StandaloneShell";

// Mark this as the standalone build for the shared nerdlet source, which reads
// the flag from globalThis to keep its global roll-up requests same-origin
// (see constants/healthEndpoints.js). Never set inside a nerdpack.
globalThis[STANDALONE_GLOBAL] = true;

// Baseline the New Relic shell would otherwise supply, then the nerdlet's own
// stylesheets. Inside a nerdpack, New Relic auto-loads the files under
// nerdlets/home/, which is why nothing in the shared source imports them.
import "./nr1/nr1-compat.css";
import "./nerdlets/home/main.css";
import "./nerdlets/home/styles.scss";
// Standalone-only: the nerdlet fills whatever width New Relic gives it.
import "./standalone-layout.css";
import "./landing.css";
import "./entity/entity-panel.css";

// React 17 (matching the version the New Relic platform runs) uses the legacy
// render API rather than createRoot.
async function bootstrap() {
  const container = document.getElementById("root");
  const config = await resolveConfig();
  // Publish the health API origin for the shared nerdlet source, which reads it
  // from globalThis (it cannot import this standalone-only module). Set before
  // render so the first fetch sees the resolved value. See constants/healthApi.js.
  globalThis[HEALTH_API_BASE_GLOBAL] = config.healthApiBase;
  setRuntimeConfig(config);
  configureCognito(config.cognito);
  ReactDOM.render(<StandaloneShell config={config} />, container);
}

bootstrap();
